import { Tenant } from "@/api/tenant.api";
import { ApiService } from "../api/api.service";
import { AxiosError } from "axios";
import { useTenantStore } from "@/store/tenant/tenant.store";

class TenantService extends ApiService {
    async getAvailableTenants(): Promise<Tenant[]> {
        const response = await this.axios.get<Tenant[]>("/tenants");
        return response.data;
    }

    async getTenant(id: number): Promise<Tenant | null> {
        try {
            const response = await this.axios.get<Tenant>(`/tenants/${id}`);
            return response.data;
        } catch (error) {
            if ((error as AxiosError)?.response?.status === 404) {
                useTenantStore.getState().selectTenant(undefined);
            }
            return null;
        }
    }
}

export const tenantService = new TenantService();
